export default __webpack_public_path__ + "static/media/cvhnet2.19b5c03e.png";